import type {
  PeriodExpiredMessagePropsMappedFromDispatch,
  PeriodExpiredMessagePropsMappedFromState
} from '@console/components/project/PeriodExpiredMessage';
import PeriodExpiredMessage from '@console/components/project/PeriodExpiredMessage';
import type { AppState } from '@console/reducers';
import { getSelectedProjectDetail } from '@console/selectors/projectDetail';
import { connect } from 'react-redux';

const mapStateToProps = (
  state: AppState
): PeriodExpiredMessagePropsMappedFromState => ({
  selectedProject: getSelectedProjectDetail(state)
});

const mapDispatchToProps =
  (): PeriodExpiredMessagePropsMappedFromDispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PeriodExpiredMessage);
